module.exports = __webpack_public_path__ + "img/textnosso.20eb55d0.png";